import React from "react";
import { motion, AnimatePresence } from "framer-motion";

export const Rofl = () => {
  return (
    <motion.g
      id="Rofl"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
      exit={{ opacity: 0 }}
    >
      <circle cx="20" cy="20" r="20" style={{ fill: "#ffdc0a" }} />
      <g id="line">
        <path
          d="M54.2,32a22.16,22.16,0,0,1-7.55,16.66l.46.92a23.16,23.16,0,0,0-.73-35.77l-.74.7A22.16,22.16,0,0,1,54.2,32Z"
          transform="translate(-12 -11.37)"
          style={{ fill: "#231f20" }}
        />
      </g>
      <polygon
        id="arrow"
        points="31.39 0 33.13 6.5 37.89 1.74 31.39 0"
        style={{ fill: "#231f20" }}
      />
      <g id="text">
        <path
          d="M23,36.29a2.17,2.17,0,0,1,1.38-.72,1.6,1.6,0,0,1,1.29.53,2,2,0,0,1,.56.95A1.41,1.41,0,0,1,26,38.11v0a1.11,1.11,0,0,1,.47-.2,1,1,0,0,1,.43,0,1.76,1.76,0,0,1,.4.18,4.44,4.44,0,0,1,.38.27l.37.33c.13.12.26.22.39.32a2.92,2.92,0,0,0,.4.25,1.36,1.36,0,0,0,.42.13l-.7.7a.58.58,0,0,1-.28-.11,2.27,2.27,0,0,1-.31-.25l-.35-.32a3.52,3.52,0,0,0-.39-.31,3.85,3.85,0,0,0-.4-.26,1,1,0,0,0-.4-.15.84.84,0,0,0-.41,0,1.43,1.43,0,0,0-.44.3L24.1,40.6l2,2-.63.63-4.73-4.72Zm2.27,2a1.29,1.29,0,0,0,.22-.48,1,1,0,0,0,0-.5,1.23,1.23,0,0,0-.33-.51,1.2,1.2,0,0,0-.78-.38,1.15,1.15,0,0,0-.87.42l-1.56,1.56,1.65,1.65,1.31-1.31A3.79,3.79,0,0,0,25.26,38.31Z"
          transform="translate(-12 -11.37)"
        />
        <path
          d="M26.61,35.54a3.19,3.19,0,0,1-.37-1.22,3,3,0,0,1,.16-1.26,3.31,3.31,0,0,1,.78-1.19,3.26,3.26,0,0,1,1.19-.78,2.89,2.89,0,0,1,1.26-.16,3.19,3.19,0,0,1,1.22.37,4.25,4.25,0,0,1,1.07.78,4.11,4.11,0,0,1,.79,1.08,3.33,3.33,0,0,1,.37,1.21,3.05,3.05,0,0,1-.17,1.26,3.26,3.26,0,0,1-.78,1.19,3.31,3.31,0,0,1-1.19.78,2.86,2.86,0,0,1-1.25.16,3.36,3.36,0,0,1-1.22-.36,4.34,4.34,0,0,1-1.08-.79A4.25,4.25,0,0,1,26.61,35.54Zm2.21,1.06a2.82,2.82,0,0,0,.92.33,2.29,2.29,0,0,0,2.44-1.55,2.2,2.2,0,0,0,.06-1,2.61,2.61,0,0,0-.33-.92,4,4,0,0,0-.62-.8,3.62,3.62,0,0,0-.79-.61,2.93,2.93,0,0,0-.92-.34,2.11,2.11,0,0,0-1.87.64,2.2,2.2,0,0,0-.57.91,2,2,0,0,0-.06,1,2.68,2.68,0,0,0,.33.92A4.27,4.27,0,0,0,28,36,4.39,4.39,0,0,0,28.82,36.6Z"
          transform="translate(-12 -11.37)"
        />
        <path
          d="M33.43,25.85l.53.53-2.47,2.47,1.5,1.5,2.17-2.17.53.53-2.17,2.17,2.16,2.17-.62.63L30.33,29Z"
          transform="translate(-12 -11.37)"
        />
        <path
          d="M34.76,24.52,39,28.72l2.51-2.5.53.53-3.14,3.13-4.72-4.73Z"
          transform="translate(-12 -11.37)"
        />
        <path
          d="M42.51,24.75l.73.74-.73.73-.73-.73Zm-.7-.25-.29.29L39.29,22.9l-1.45-1.46.62-.63,1.46,1.46Z"
          transform="translate(-12 -11.37)"
        />
      </g>
    </motion.g>
  );
};

const UpsideDown = () => {
  return (
    <motion.g
      id="UpsideDown"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
      exit={{ opacity: 0 }}
    >
     <path d="M41.66,34.3a2.26,2.26,0,0,1,1.62-.53,2.52,2.52,0,0,1,1.68.51,2,2,0,0,1,.61,1.62v3.56h-.74V35.9a1.47,1.47,0,0,0-.4-1.13,1.57,1.57,0,0,0-1.15-.39,1.43,1.43,0,0,0-1.08.39,1.58,1.58,0,0,0-.37,1.13v3.56h-.74V35.9A2.1,2.1,0,0,1,41.66,34.3Z" transform="translate(-12 -12)"/>
      <path d="M37.47,39.46A1.74,1.74,0,0,1,36.19,39a1.65,1.65,0,0,1,1.28-2.85h1.7V33.89h.74v5.57Zm.25-2.67a1.36,1.36,0,0,0-.93.26,1.14,1.14,0,0,0,0,1.52,1.36,1.36,0,0,0,.93.26h1.45v-2Z" transform="translate(-12 -12)"/>
      <path d="M32.07,38.7A1.57,1.57,0,0,0,33,39a2.4,2.4,0,0,0,.46,0,1.09,1.09,0,0,0,.4-.16.78.78,0,0,0,.28-.29.9.9,0,0,0,.1-.46.56.56,0,0,0-.15-.41,1,1,0,0,0-.4-.26,2.84,2.84,0,0,0-.58-.17L32.48,37c-.22-.05-.43-.11-.65-.18a2.16,2.16,0,0,1-.57-.28,1.27,1.27,0,0,1-.4-.46,1.29,1.29,0,0,1-.16-.68,1.41,1.41,0,0,1,.2-.76,1.69,1.69,0,0,1,.51-.52,2.28,2.28,0,0,1,.7-.28,3.37,3.37,0,0,1,.77-.09,3.17,3.17,0,0,1,.88.11,2.17,2.17,0,0,1,.73.36,1.57,1.57,0,0,1,.5.61,1.8,1.8,0,0,1,.19.87h-.7a1.27,1.27,0,0,0-.14-.6A1.22,1.22,0,0,0,34,34.7a1.46,1.46,0,0,0-.52-.24,2.49,2.49,0,0,0-.61-.08,2.92,2.92,0,0,0-.5,0,1.4,1.4,0,0,0-.46.16.86.86,0,0,0-.32.31.84.84,0,0,0-.13.5.69.69,0,0,0,.15.46,1.28,1.28,0,0,0,.41.3,3.83,3.83,0,0,0,.57.18l.65.14.66.17a3,3,0,0,1,.57.26,1.24,1.24,0,0,1,.4.42A1.2,1.2,0,0,1,35,38a1.44,1.44,0,0,1-.18.73,1.57,1.57,0,0,1-.45.51,2,2,0,0,1-.65.29,2.64,2.64,0,0,1-.74.1,2.92,2.92,0,0,1-.8-.1,1.92,1.92,0,0,1-.64-.32,1.58,1.58,0,0,1-.44-.55,2.09,2.09,0,0,1-.17-.79h.7A1.15,1.15,0,0,0,32.07,38.7Z" transform="translate(-12 -12)"/>
      <path d="M29,39.46V33.89h.74v5.57Z" transform="translate(-12 -12)"/>
      <path d="M25.88,39.46a2.75,2.75,0,0,1-2-.66,2.58,2.58,0,0,1-.7-2,4.68,4.68,0,0,1,.16-1.25,2.27,2.27,0,0,1,.48-.91,2.07,2.07,0,0,1,.84-.56,3.27,3.27,0,0,1,1.2-.2h1.91v5.57Zm-.07-5-.31,0a2.24,2.24,0,0,0-.39.1,1.83,1.83,0,0,0-.42.21,1.34,1.34,0,0,0-.37.38,2.16,2.16,0,0,0-.27.61,3.15,3.15,0,0,0-.11.88,4,4,0,0,0,.1.89,1.81,1.81,0,0,0,.32.67,1.51,1.51,0,0,0,.57.42,2.24,2.24,0,0,0,.87.14h1.25V34.51Z" transform="translate(-12 -12)"/>
      <path d="M18.45,39.46v-.63h3.11V37.06H18.67v-.62h2.89V34.51H18.43v-.62H22.3v5.57Z" transform="translate(-12 -12)"/>
      <path d="M41.76,30.1a2.79,2.79,0,0,1-2-.65,2.62,2.62,0,0,1-.7-2,4.24,4.24,0,0,1,.16-1.24,2.31,2.31,0,0,1,.48-.92,2.18,2.18,0,0,1,.84-.56,3.28,3.28,0,0,1,1.2-.19h1.91V30.1Zm-.07-4.94-.31,0a1.73,1.73,0,0,0-.4.09,1.64,1.64,0,0,0-.41.22,1.34,1.34,0,0,0-.37.38,2.09,2.09,0,0,0-.27.6,3.2,3.2,0,0,0-.11.88,4,4,0,0,0,.1.89,1.74,1.74,0,0,0,.32.67,1.33,1.33,0,0,0,.57.42,2.26,2.26,0,0,0,.87.15h1.25V25.16Z" transform="translate(-12 -12)"/>
      <path d="M38.32,28.41a2.83,2.83,0,0,1-.5.94A2.4,2.4,0,0,1,37,30a2.69,2.69,0,0,1-1.17.24A2.64,2.64,0,0,1,34.66,30a2.4,2.4,0,0,1-.83-.64,2.66,2.66,0,0,1-.5-.94,3.32,3.32,0,0,1-.17-1.09,3.38,3.38,0,0,1,.17-1.1,2.62,2.62,0,0,1,.5-.93,2.4,2.4,0,0,1,.83-.64,2.64,2.64,0,0,1,1.16-.24,2.69,2.69,0,0,1,1.17.24,2.4,2.4,0,0,1,.83.64,2.78,2.78,0,0,1,.5.93,3.67,3.67,0,0,1,.17,1.1A3.6,3.6,0,0,1,38.32,28.41Zm-.68-1.92a2.28,2.28,0,0,0-.34-.74A1.75,1.75,0,0,0,35.82,25a1.75,1.75,0,0,0-.87.2,1.77,1.77,0,0,0-.6.52,2.09,2.09,0,0,0-.34.74,3.19,3.19,0,0,0,0,1.66,2.17,2.17,0,0,0,.34.74,1.88,1.88,0,0,0,.6.52,2,2,0,0,0,1.75,0,1.88,1.88,0,0,0,.6-.52,2.38,2.38,0,0,0,.34-.74,3.19,3.19,0,0,0,0-1.66Z" transform="translate(-12 -12)"/>
      <path d="M28,24.54l1.27,4.67h0l1.29-4.67h.77l1.43,5.56H32l-1.09-4.63h0L29.66,30.1h-.8l-1.24-4.63h0L26.48,30.1h-.74l1.48-5.56Z" transform="translate(-12 -12)"/>
      <path d="M24.26,30.1l-2.94-4.51h0V30.1h-.7V24.54h.81L24.33,29h0V24.54H25V30.1Z" transform="translate(-12 -12)"/>
    </motion.g>
  );
};

export default ({ selected }) => {
  return (
    <g id="effect">
      <AnimatePresence>
        {selected === "Rofl" && <Rofl key={selected} />}
        {selected === "UpsideDown" && <UpsideDown key={selected} />}
      </AnimatePresence>
    </g>
  );
};

export const effectList = [Rofl, UpsideDown];
